module.exports = __webpack_public_path__ + "img/phone.44fd2cdf.svg";